import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  borderRadius: 4,
  gap: 8,
  padding: '8px',
  border: `1px solid ${spaceCadet[300]}`,

  '& > .MuiTypography-subtitle1': {
    fontSize: 14,
    lineHeight: '24px',
  },
  '& > .MuiButtonBase-root': {
    fontSize: 14,
    lineHeight: '20px',
    textTransform: 'none',
  },
  '& > .MuiBox-root': {
    width: '100%',
  },
});

export default StyledBox;
